import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAnnouncement02Filled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.03762 14.2736C1.7945 13.2652 1 11.7254 1 9.99999C1 6.96242 3.46243 4.49999 6.5 4.49999H10.25C12.0506 4.49999 13.8577 3.58842 15.4002 2.74747C15.857 2.49849 16.2493 2.2846 16.5669 2.14128C16.8593 2.00935 17.2851 1.83943 17.7431 1.89553C18.3164 1.96574 18.7906 2.24734 19.1266 2.71706C19.3906 3.08606 19.4484 3.52389 19.4735 3.83962C19.5203 4.42784 19.5 5.02175 19.5 5.61151C21.504 6.06624 23 7.85841 23 10C23 12.1416 21.504 13.9338 19.5 14.3885C19.5 14.9782 19.5203 15.5721 19.4735 16.1604C19.4484 16.4761 19.3906 16.9139 19.1266 17.2829C18.7906 17.7526 18.3164 18.0342 17.7431 18.1044C17.2851 18.1605 16.8593 17.9906 16.5669 17.8587C16.1556 17.6731 15.7615 17.4495 15.3657 17.2336C13.9717 16.4738 12.3629 15.7675 11 15.5607C11 17.1196 11.1366 18.7367 10.986 20.2896C10.8475 21.7175 9.71748 22.8475 8.2896 22.986C7.97234 23.0168 7.63469 23.016 7.31699 22.99C6.12449 22.8925 5.10396 22.0957 4.72012 20.9624C4.68043 20.8453 4.64878 20.7185 4.61232 20.5724L3.03762 14.2736ZM19.5 12.292C20.383 11.9062 21 11.0252 21 10C21 8.97484 20.383 8.0938 19.5 7.70802V12.292Z",
		fill: "currentColor"
	})
});
export default SvgAnnouncement02Filled;
